import "./VideoPlayer.scss";
import play from "../../assets/Icons/play.svg";
import fullscreen from "../../assets/Icons/fullscreen.svg";
import volume from "../../assets/Icons/volume_up.svg";
import Loader from "../Loader/Loader";

function VideoPlayer({ video, img, loading }) {
  return (
    <div className="video">
      <div className="video__wrapper">
        <video className="video__player" src={video} poster={img}></video>
        {loading && (
          <div className="video__loader">
            <Loader />
          </div>
        )}

        <div className="controls">
          <button className="controls__btn">
            <img className="controls__img" src={play} alt="" />
          </button>
          <div className="controls__timeline">
            <input
              type="range"
              className="controls__scrub"
              min="0"
              max="100"
              step="1"
              value="0"
            />
            <span>0:00/4:15</span>
          </div>
          <div className="controls__secondary">
            <button className="controls__btn controls__secondary-btn">
              <img
                className="controls__img controls__secondary-img"
                src={fullscreen}
                alt=""
              />
            </button>
            <button
              className="controls__btn controls__secondary-btn"
              id="volume"
            >
              <img
                className="controls__img controls__secondary-img"
                src={volume}
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VideoPlayer;
